import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { motion, useMotionValue, useSpring } from "framer-motion";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { WhatsAppFloat } from "./components/WhatsAppFloat";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Stories from "./pages/Stories";
import BookAppointment from "./pages/BookAppointment";

const CursorFollower = () => {
  const [enabled, setEnabled] = useState(false);
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const ringX = useSpring(x, { stiffness: 180, damping: 20, mass: 0.6 });
  const ringY = useSpring(y, { stiffness: 180, damping: 20, mass: 0.6 });

  useEffect(() => {
    if (!window.matchMedia("(pointer: fine)").matches) return;
    setEnabled(true);
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };
    window.addEventListener("mousemove", move, { passive: true });
    return () => window.removeEventListener("mousemove", move);
  }, [x, y]);

  if (!enabled) return null;
  return (
    <>
      <motion.div
        data-testid="cursor-dot"
        className="pointer-events-none fixed left-0 top-0 z-[9999] h-2 w-2 rounded-full bg-[#4CA6AF]"
        style={{ x, y, translateX: "-50%", translateY: "-50%" }}
      />
      <motion.div
        data-testid="cursor-ring"
        className="pointer-events-none fixed left-0 top-0 z-[9998] h-8 w-8 rounded-full border-2 border-[#4CA6AF]/50"
        style={{ x: ringX, y: ringY, translateX: "-50%", translateY: "-50%" }}
      />
    </>
  );
};

const ScrollManager = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const tryScroll = (attempts) => {
        const el = document.querySelector(location.hash);
        if (el) {
          if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
          else el.scrollIntoView({ behavior: "smooth" });
          setTimeout(() => {
            const again = document.querySelector(location.hash);
            if (again && window.__lenis) window.__lenis.scrollTo(again, { offset: -72 });
          }, 900);
        } else if (attempts > 0) {
          setTimeout(() => tryScroll(attempts - 1), 120);
        }
      };
      setTimeout(() => tryScroll(6), 80);
    } else {
      if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
      else window.scrollTo(0, 0);
    }
  }, [location]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollManager />
      <div className="min-h-screen bg-white font-body">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/stories" element={<Stories />} />
          <Route path="/book" element={<BookAppointment />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
        <CursorFollower />
        <WhatsAppFloat />
      </div>
    </BrowserRouter>
  );
}

export default App;
